export const NewClientContactGetters = {
  NewClientContact: 'getNewClientContact'
};
